// extracted by mini-css-extract-plugin
module.exports = {"speech-card-box":"eH","speechCardBox":"eH","speech-img-box":"eI","speechImgBox":"eI","card-content":"eJ","cardContent":"eJ","card-src":"eK","cardSrc":"eK"};